import React from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import Title from '@Components/Title';
import withOnHoverStuff from '@Hooks/withOnHoverStuff';

export function calcLeft(zoomValue, max, min) {
  if (zoomValue === min) {
    return 0;
  }

  return `${((zoomValue - min) / (max - min)) * 100}`;
}

export class ZoomSliderBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      doesMousePressed: false,
    };

    this.wrapperRef = React.createRef();
  }

  calcValue = throttle((e) => {
    const { max, min, zoomValue, plus, minus } = this.props;
    const { left, right } = this.wrapperRef.current.getBoundingClientRect();
    const width = right - left;
    const partsCount = max - min;
    const { clientX } = e;
    let positionClickOnWrapper = clientX - left;

    if (positionClickOnWrapper < 0) {
      positionClickOnWrapper = 0;
    }

    if (positionClickOnWrapper > width) {
      positionClickOnWrapper = width;
    }

    const valueAccordingToClick = Math.round((partsCount * positionClickOnWrapper) / width);

    if (valueAccordingToClick > zoomValue) {
      plus();
    }

    if (valueAccordingToClick < zoomValue) {
      minus();
    }
  }, 20);

  onMouseDownHandler = (e) => {
    e.persist();

    window.addEventListener('mousemove', this.calcValue);
    window.addEventListener('mouseup', this.onMouseUpHandler);

    this.setState({
      doesMousePressed: true,
    });

    this.calcValue(e);
  };

  onMouseUpHandler = (e) => {
    window.removeEventListener('mousemove', this.calcValue);
    window.removeEventListener('mouseup', this.onMouseUpHandler);

    this.setState({
      doesMousePressed: false,
    });

    this.calcValue(e);
  };

  render() {
    const { max, min, zoomValue, isHovered, onMouseEnterHandler, onMouseLeaveHandler } = this.props;
    const { doesMousePressed } = this.state;
    const markShift = calcLeft(zoomValue, max, min);

    return (
      <div
        ref={this.wrapperRef}
        className="zoom-slider-slide-wrapper"
        onMouseDown={this.onMouseDownHandler}
        onMouseEnter={onMouseEnterHandler}
        onMouseLeave={onMouseLeaveHandler}>
        <div
          className="zoom-slider-mark"
          style={{
            left: `${markShift}%`,
          }}>
          <Title isOpen={isHovered || doesMousePressed}>{zoomValue}</Title>
        </div>
      </div>
    );
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.calcValue);
    window.removeEventListener('mouseup', this.onMouseUpHandler);
  }
}

ZoomSliderBar.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  plus: PropTypes.func.isRequired,
  minus: PropTypes.func.isRequired,
  zoomValue: PropTypes.number.isRequired,
  isHovered: PropTypes.bool.isRequired,
};

export default withOnHoverStuff({
  debounceTime: 300,
})(ZoomSliderBar);
